import { render, staticRenderFns } from "./InfoPromotions.vue?vue&type=template&id=767b2e0b&scoped=true&"
import script from "./InfoPromotions.vue?vue&type=script&lang=js&"
export * from "./InfoPromotions.vue?vue&type=script&lang=js&"
import style0 from "./InfoPromotions.vue?vue&type=style&index=0&id=767b2e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b2e0b",
  null
  
)

export default component.exports